import { Briefcase, ChefHat, ClipboardList, Stethoscope, Users, Wrench } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { IMAGES, TEAM } from "@/data/content";

const ICONS = { Briefcase, ClipboardList, Users, Stethoscope, ChefHat, Wrench };

const Team = () => (
  <section id="team" data-testid="team-section" className="bg-beige py-24 sm:py-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading
        chapter="05"
        eyebrow="Il Nostro Team"
        title="Le persone che si prendono cura dei vostri cari"
        text="Il vero valore di Orto della Longevità sono le persone. Ogni giorno il nostro team lavora con professionalità, sensibilità e attenzione per garantire agli ospiti un ambiente sereno e familiare."
        testid="team-heading"
        hint="team-scroll-hint"
      />
      <div className="mt-8 flex touch-pan-x snap-x snap-mandatory gap-4 overflow-x-auto pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden lg:mt-16 lg:touch-auto lg:grid lg:grid-cols-3 lg:gap-6 lg:overflow-visible lg:pb-0">
        {TEAM.map((t, i) => {
          const Icon = ICONS[t.icon];
          return (
            <Reveal key={t.dept} delay={i * 0.08} className="w-[80%] shrink-0 snap-start lg:w-auto">
              <div data-testid={`team-card-${i}`} className="h-full rounded-3xl bg-ivory p-7 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:shadow-sage/10">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-sage-light text-sage">
                  <Icon size={20} strokeWidth={1.7} />
                </span>
                <h3 className="mt-4 font-serif text-xl font-medium text-ink">{t.dept}</h3>
                <p className="mt-2 text-sm leading-relaxed text-moss">{t.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.15}>
        <div className="relative mt-16 overflow-hidden rounded-[2.5rem]" data-testid="team-family-banner">
          <img src={IMAGES.hands} alt="Il team di Orto della Longevità: una grande famiglia" className="h-[340px] sm:h-[420px] w-full object-cover" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink/75 via-ink/40 to-transparent" />
          <div className="absolute inset-0 flex items-center px-8 sm:px-14">
            <div className="max-w-lg">
              <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-terracotta">Una grande famiglia</p>
              <p className="mt-4 font-serif text-2xl sm:text-4xl font-medium italic leading-snug text-ivory">
                “Dietro ogni sorriso dei nostri ospiti c'è l'impegno quotidiano di un'intera squadra.”
              </p>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Team;
